<template>
  <div>
    <generic-modal
      :height="LoginModalDim.height"
      :width="LoginModalDim.width"
      :padding="LoginModalDim.padding"
      :modalClass="LoginModalDim.modalClass"
      overflowNotNeeded="true"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <img
          :src="staticImgBaseUrl + '/images/global/hongs-default-img-lg.png'"
          alt="hongs-kitchen-icon"
          class="onboarding-logo"
        />
        <img
          :src="
            staticImgBaseUrl + '/images/global/logo-hongs-kitchen-wordmark.svg'
          "
          alt="hongs-kitchen-icon"
          class="onboarding-logo-label"
        />
      </template>
      <template v-slot:footer>
        <div class="onboarding-footer">
          <img
            :src="staticImgBaseUrl + '/images/global/jubilant-icon.svg'"
            alt="jubilant-icon"
            class="mr8"
          />
          <span>Jubilant FoodWorks</span>
        </div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import { staticImgBaseUrl } from "../config/apiEndpoints";
export default {
  name: "Onboarding",
  components: {
    GenericModal,
  },
  // props: ['dataResults'],
  data() {
    return {
      LoginModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "login-modal full-screen-popup  lg-screen-centered",
      },
      staticImgBaseUrl: staticImgBaseUrl,
    };
  },
  mounted() {
    // console.log("this.dataResults ==>", this.dataResults);
  },
  methods: {
    //
  },
};
</script>
